jQuery(function($){ 
 
  
  $(".btn-size").on("click", function() {
    $(".bg-overlay").addClass("active");
    $(".popup").addClass("active"); 
  });
  
  // Home Popup
  
  jQuery(".bg-overlay,.icon-cross").on("click", function(e){
    e.preventDefault();
    $(".bg-overlay").removeClass("active");
    $(".popup").removeClass("active");
  });  

  
	// Anchor smooth scrolls
	$("body").on("click",".a-link",function(o){o.preventDefault();var e=this.hash,t=$(e);$("html, body").animate({scrollTop:t.offset().top},{duration:1e3,step:function(o,e){var n=t.offset().top;e.end!==n&&(e.end=n)}}),$("body").removeClass("show-menu")});
  
  
});